import { useMantineTheme } from '@mantine/core';

export const useTheme = useMantineTheme;
